(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["slow-window"] && !Shopify.designMode) return;
  try {
    // Wait for page to be ready
  document.addEventListener('DOMContentLoaded', function() {
    var slowWindow = document.querySelector('.slow-window');
    if (!slowWindow) return;

    // Fade it out
    slowWindow.classList.add('is-hidden');

    // Remove after transition
    setTimeout(function() {
      slowWindow.remove();
    }, 300);
  });
  } catch(e) { console.error(e); }
})();

})();
